// extracted by mini-css-extract-plugin
export default {"wrap":"PageHeader_wrap__91UEa","title-wrap":"PageHeader_title-wrap__U7V3Q"};